import * as React from "react";

export const SvgLinkedin = (props) => (
	<svg width={39} height={38} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M27.203 26.648h.003v-5.561c0-2.72-.585-4.817-3.766-4.817-1.529 0-2.555.84-2.974 1.635h-.044v-1.38h-3.015v10.123h3.14v-5.013c0-1.32.25-2.596 1.884-2.596 1.61 0 1.635 1.506 1.635 2.68v4.93h3.137ZM12.293 16.525h3.144v10.123h-3.143V16.526ZM13.864 11.485c-1.005 0-1.82.816-1.82 1.821s.815 1.838 1.82 1.838c1.005 0 1.82-.833 1.82-1.838 0-1.005-.815-1.82-1.82-1.82Z"
			fill="#FFB11A"
		/>
		<circle cx={19.5} cy={19} r={18.5} stroke="#FFB11A" />
	</svg>
);
